import { Breadcrumb } from "antd";
import { useState } from "react";
import TestimonialTabs from "./testmonialTabs";

const Testimonial = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Testimonial</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Testimonial" }, { title: breadcrumb }]}
        />
      </div>
      <TestimonialTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default Testimonial;
